import ProjectCollectionModel from "../project-collection-model";

const debug = false
// const debug = "ProjectCollectionActions"

export default class ProjectCollectionActions {

    public projectCollection : ProjectCollectionModel

    constructor(projectCollection: ProjectCollectionModel) {
        this.projectCollection = projectCollection
    }

    delete = () => {
        gd.modals.portfolio.deletePortfolio(this.projectCollection.id)
    }

    addUsers = (callback:callback) => {
        const hiddenUsersIds = _.compact([this.projectCollection.ownerUserId].concat(_.map(this.projectCollection.users, user=>user.userId)))

        gd.modals.portfolio.addUsers(hiddenUsersIds, true, (result:any)=>{
            debug && console.log(debug, 'addUsers', result)

            this.projectCollection.users = _.compact(_.uniqBy([...this.projectCollection.users, ...result], user=>user.userId))
            this.projectCollection.save()

            callback && callback()
        })
    }
}